// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8pgko","footerContent":"Footer_footerContent__+webY","footerText":"Footer_footerText__AesFc","scrollToTop":"Footer_scrollToTop__RqTsn"};